'use strict';
const NodeContentAllocation = require('balus/domain/entity/allocation/node-content');
const NodeContentAllocationRepository = require('balus/infra/repository/allocation/node-content');
const NodeContentAllocationAPI = require('balus/infra/api/allocation/node-content');

class Service {
    /**
     * NodeContentAllocation を追加するためのサービス
     *
     * @param {Project} project
     * @param {Node} node
     * @param {DataContent} content
     */
    constructor(project, node, content) {
        this._project = project;
        this._node = node;
        this._content = content;
    }

    create() {
        return NodeContentAllocationAPI.create(this._project.id, this._node.id, this._content.id)
            .then(allocationJSON => {
                NodeContentAllocationRepository.find(this._project)
                    .add(new NodeContentAllocation({
                        id: allocationJSON.id,
                        model: this._node,
                        specific: this._content
                    }));
            })
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./balus/app/service/allocation/node-content/create.js